{"id":"ProductDetail.Info","prefabs":{"default":{"children":[{"component":"ProductDetail.Info","options":"options:*"}]}}}